import * as React from 'react';
import { compKey } from './key';
import { namespacedClassnames } from '../../common';
import { Label } from '../../new-libby/core/labels';
import { Tooltip } from '../../primitives/tooltip/tooltip';
import { LibColor, OverflowLabelView, Text } from '../../new-libby';
import * as classNames from 'classnames';
import { Layout } from '../../primitives/layout';
export var LabelList = function (props) {
    var LabelListClassNames = namespacedClassnames(compKey, props.className);
    var title = React.createElement(Text, { className: 'label-list-title', type: 'ts', color: 't40' }, props.title);
    var labelList = props.labels.map(function (label) {
        var highlighted = label.highlighted, avatar = label.avatar, text = label.text, onClick = label.onClick;
        var labelItem = (React.createElement(Label, { className: classNames('label-list-item'), size: 'small', color: highlighted ? LibColor.white : LibColor.sky120, hoverColor: highlighted ? LibColor.sky130 : LibColor.sky110, borderColor: LibColor.sky110, onClick: onClick },
            avatar,
            React.createElement(Text, { className: 'label-text' }, text)));
        return label.tooltip ? React.createElement(Tooltip, { body: label.tooltip }, labelItem) : labelItem;
    });
    return (React.createElement("div", { className: LabelListClassNames },
        React.createElement(Layout, { gap: '6', orientation: 'horizontal', verticalAlignment: 'center' },
            props.titleTooltip ? React.createElement(Tooltip, { body: props.titleTooltip }, title) : title,
            React.createElement(OverflowLabelView, { className: 'overflow', labels: labelList, showMoreLabelsize: 'small' }))));
};
//# sourceMappingURL=index.js.map